var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuTransactionsSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7692,
    cy: 13,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01923 8.55087C10.0587 7.43954 11.5076 6.75 13.1101 6.75C13.7352 6.75 14.3369 6.8549 14.9 7.0488M11.3204 18.4512C11.8835 18.6451 12.4851 18.75 13.1101 18.75C14.748 18.75 16.2254 18.0297 17.2692 16.875",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57505 6.28445C7.48147 6.10998 7.31505 6 7.13598 6C6.95691 6 6.79099 6.1071 6.69792 6.28042L3.09379 13.0352C2.99767 13.216 2.99413 13.5355 3.08519 13.7198C3.17573 13.9029 3.34671 14.1419 3.53235 14.1419L4.74688 14.1419C5.11918 14.1419 5.43533 14.3843 5.49502 14.8029C5.80915 17.0024 7.46832 18.75 9.46893 18.75C10.0663 18.75 10.6314 18.583 11.1407 18.317C11.2191 18.2761 11.2692 18.1782 11.2692 18.0792C11.2687 17.9807 11.2171 17.888 11.1387 17.8477C10.1033 17.3174 9.3015 16.3017 8.95347 15.0568C8.88519 14.8138 8.92312 14.6123 9.05515 14.4067C9.18717 14.2012 9.39811 14.1419 9.6222 14.1419L10.7401 14.1419C10.9253 14.1419 11.0967 13.904 11.1878 13.7209C11.2793 13.5367 11.2753 13.2194 11.1787 13.0386L7.57505 6.28445Z",
    fill: "white",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1553 6.42855C15.0742 6.46772 15.0205 6.56564 15.0205 6.66644C15.0199 6.76667 15.0727 6.86114 15.1537 6.90088C16.3863 7.50742 17.0107 8.57304 17.3234 9.68762C17.3919 9.9307 17.3544 10.1473 17.2221 10.3529C17.0893 10.5591 16.8785 10.6311 16.6544 10.6311L15.5339 10.6311C15.3479 10.6311 15.1766 10.8552 15.0858 11.0384C14.9936 11.2227 14.9976 11.532 15.095 11.7135L18.7055 18.466C18.7988 18.6406 18.9655 18.75 19.1445 18.75C19.3239 18.75 19.4906 18.6417 19.5839 18.4678L23.1945 11.71C23.2907 11.5297 23.2943 11.2238 23.2036 11.0395C23.1123 10.8563 22.941 10.6311 22.755 10.6311L21.5382 10.6311C21.1657 10.6311 20.8494 10.3748 20.7886 9.95604C20.4738 7.75568 18.812 6 16.807 6C16.3458 6 15.7062 6.16301 15.1553 6.42855Z",
    fill: "white",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuTransactionsSelected);
export default __webpack_public_path__ + "static/media/ic-menu-transactions-selected.e4840ea52021d3dd30d1c9805c7c8709.svg";
export { ForwardRef as ReactComponent };